import type { ServiceUnit } from "@msuite/utils/types";
import type { CalculationFormItemPositionFieldsSharedProps } from "./calculation-form-item-position-fields-shared";
import { CalculationFormItemPositionFieldsCubicMeters } from "./calculation-form-item-position-fields-cubic-meters";
import { CalculationFormItemPositionFieldsMeters } from "./calculation-form-item-position-fields-meters";
import { CalculationFormItemPositionFieldsPiece } from "./calculation-form-item-position-fields-piece";
import { CalculationFormItemPositionFieldsSquareMeters } from "./calculation-form-item-position-fields-square-meters";

/** Props Interface */
interface CalculationFormItemPositionFieldsProps
	extends CalculationFormItemPositionFieldsSharedProps {
	unit: ServiceUnit;
}

export function CalculationFormItemPositionFields({
	unit,
	index,
	positionIndex,
}: CalculationFormItemPositionFieldsProps) {
	if (unit === "piece" || unit === "piece-week")
		return (
			<CalculationFormItemPositionFieldsPiece
				index={index}
				positionIndex={positionIndex}
			/>
		);
	if (unit === "meters" || unit === "meters-week")
		return (
			<CalculationFormItemPositionFieldsMeters
				index={index}
				positionIndex={positionIndex}
			/>
		);
	if (unit === "square-meters" || unit === "square-meters-week")
		return (
			<CalculationFormItemPositionFieldsSquareMeters
				index={index}
				positionIndex={positionIndex}
			/>
		);
	if (unit === "cubic-meters")
		return (
			<CalculationFormItemPositionFieldsCubicMeters
				index={index}
				positionIndex={positionIndex}
			/>
		);
	return null;
}
